import assert from '@/sui/tools/assert'

function buildKey (name, module, step) {
  const mod = module === '' || module == null ? 'all' : module
  return `${name}-${mod}-${step}`
}

function getDatasetType (dataset) {
  assert.notNull(dataset)
  assert.isString(dataset)

  if (dataset.match(/-/) == null) {
    return 1
  }

  if (dataset.match(/-OBS[4P]-/) != null) {
    return 2
  }

  if (dataset.match(/-SURV-/) != null) {
    return 3
  }

  if (dataset.match(/-CAUSE-/) != null) {
    return 4
  }

  assert(false, `Invalid dataset name ${dataset}`)
  return -1
}

function getDatasetTypeLabel (type) {
  assert.isNumber(type)

  if (type === 1) {
    return 'Journalier'
  }

  if (type === 2) {
    return 'Observation des pratiques'
  }

  if (type === 3) {
    return 'Surveillance'
  }

  if (type === 4) {
    return 'Analyse des causes'
  }

  assert(false, `Invalid dataset type ${type}`)
  return '????'
}

function filterModulesFromDatasetType (modules, type, key) {
  assert.notNull(modules)
  assert.isArray(modules)
  assert.isNumber(type)
  assert.isString(key)

  if (type === 1) {
    return modules
  }

  const moduleList = {
    2: ['observa4', 'spy4'],
    3: ['bactADI', 'expADI', 'reaInfADI', 'diaInfADI', 'neoInfADI'],
    4: ['badiCause']
  }

  const currentList = moduleList[type]
  assert.notNull(currentList)

  return modules.filter(
    m => {
      const mod = m[key]
      assert.isString(mod)
      return currentList.indexOf(mod) !== -1
    }
  )
}

function filterModulesFromDataset (modules, dataset, key) {
  const type = getDatasetType(dataset)
  return filterModulesFromDatasetType(modules, type, key)
}

export default {
  getDatasetType,
  getDatasetTypeLabel,
  filterModulesFromDatasetType,
  filterModulesFromDataset,
  buildKey
}
